"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetsClient = void 0;
const fetch_1 = require("../../utils/fetch");
const url_1 = require("../../utils/url");
class AssetsClient {
    constructor(apiOptions) {
        this.apiOptions = apiOptions;
    }
    async initiatePayment(request) {
        const path = (0, url_1.buildPathAndQuery)('/assets/asset-accounts/:assetAccountId/payments', {
            path: { assetAccountId: request.assetAccountId },
            query: {},
        });
        const response = await (0, fetch_1.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async getPaymentById(request) {
        const path = (0, url_1.buildPathAndQuery)('/assets/asset-accounts/:assetAccountId/payments/:paymentId', {
            path: {
                assetAccountId: request.assetAccountId,
                paymentId: request.paymentId,
            },
            query: {},
        });
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async listPayments(request) {
        const path = (0, url_1.buildPathAndQuery)('/assets/asset-accounts/:assetAccountId/payments', {
            path: { assetAccountId: request.assetAccountId },
            query: {},
        });
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async createAssetAccount(request) {
        const path = (0, url_1.buildPathAndQuery)('/assets/asset-accounts', {
            path: {},
            query: {},
        });
        const response = await (0, fetch_1.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async getAssetAccountById(request) {
        const path = (0, url_1.buildPathAndQuery)('/assets/asset-accounts/:assetAccountId', {
            path: { assetAccountId: request.assetAccountId },
            query: {},
        });
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async listAssetAccounts(request) {
        const path = (0, url_1.buildPathAndQuery)('/assets/asset-accounts', {
            path: {},
            query: request.query ?? {},
        });
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async getAssetAccountBalanceById(request) {
        const path = (0, url_1.buildPathAndQuery)('/assets/asset-accounts/:assetAccountId/balance', {
            path: { assetAccountId: request.assetAccountId },
            query: {},
        });
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
}
exports.AssetsClient = AssetsClient;
